import { Typography } from '@/components'
import { ThemeColor } from '@/enums'
import { themeColor } from '@/utils'
import { MessageCircleWarning } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const CoverageNotSupportedMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  svg {
    color: ${themeColor(ThemeColor.info1)};
    width: 24px;
    height: auto;
  }
`

export const CoverageNotSupported = ({
  isProductAvailable,
}: {
  isProductAvailable: boolean
}) => {
  const { t } = useTranslation()

  return (
    <>
      {!isProductAvailable ? (
        <CoverageNotSupportedMessageWrapper>
          <div>
            <MessageCircleWarning />
          </div>
          <Typography variant="p2Body">
            {t('recommendations.coverageNotSupportedMessage')}
          </Typography>
        </CoverageNotSupportedMessageWrapper>
      ) : null}
    </>
  )
}
